import authInterceptor from "../AuthInterceptor";

export const FlightModalAPI = {
  getFlightModals: () =>
    authInterceptor
      .get(`ranking-api/flight-models/`)
      .then((response) => response.data)
      .catch((error) => error.response),
  addFlightModel: (bodyData) =>
    authInterceptor
      .post(`/ranking-api/admin/flight-models/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
  saveFlightModal: (bodyData) =>
    authInterceptor
      .post(`ranking-api/flight-models/select/`, bodyData)
      .then((response) => response.data)
      .catch((error) => error.response),
};
